import { memo } from "react";
import Link from "next/link";
import Image from "next/image";

const LandscapeBanner = (props) => {
  const { styles, item } = props;
  return (
    <div
      className={`${styles.landScapeBanner} col-12 col-md-12 col-lg-12 col-xl-12`}
    >
      {item.href ? (
        <Link href={item.href} target="_blank">
          <div className={styles.promoListImg}>
            <Image
              src={item.imageUrl}
              fill
              sizes="100vw"
              style={{ objectFit: "cover" }}
            />{" "}
          </div>
        </Link>
      ) : (
        <div className={styles.promoListImg}>
          <Image
            src={item.imageUrl}
            fill
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />{" "}
        </div>
      )}
    </div>
  );
};

export default memo(LandscapeBanner);
